module.exports = __webpack_public_path__ + "static/Szopka Zielonego Balonika (ok. 1908 r.) Polona kopia-49f053cda707f98887c07aeba69849f9.jpg";